import { Avatar } from 'antd';
export { Group } from 'antd/es/avatar';
export default Avatar;
